"use strict";

exports.__esModule = true;
exports.default = void 0;

/**
 * Log a warning message to the console with bootstrap-vue formatting sugar.
 * @param {string} message
 */

/* istanbul ignore next */
function warn(message) {
  console.warn("[BootstrapVue warn]: ".concat(message));
}

var _default = warn;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/bootstrap-vue/es/utils/warn.js
// module id = 32
// module chunks = 0